import { User02Icon } from '@langchain/untitled-ui-icons';

import { ProfileCircle } from '@/components/ProfileCircle';
import { RadioGroupItem } from '@/components/RadioGroup/radio-group-item';
import { cn } from '@/utils/tailwind';

interface Organization {
  id: string;
  display_name: string;
  is_personal: boolean;
}

interface DefaultOrgSelectionCardProps {
  org: Organization;
  isSelected: boolean;
}

const OrganizationIcon = ({
  org,
  className,
}: {
  org: { is_personal: boolean; display_name: string };
  className?: string;
}) => {
  return org.is_personal ? (
    <ProfileCircle
      name={''}
      backupIcon={<User02Icon className="size-3 shrink-0 text-primary" />}
      className={className}
    />
  ) : (
    <ProfileCircle name={org.display_name} className={className} />
  );
};

export const DefaultOrgSelectionCard = ({
  org,
  isSelected,
}: DefaultOrgSelectionCardProps) => {
  return (
    <label
      className={cn(
        'flex cursor-pointer items-center gap-3 rounded-lg border p-4',
        isSelected ? 'border-primary' : 'border-secondary'
      )}
    >
      <div className="flex flex-1 items-center gap-3">
        <OrganizationIcon org={org} className="size-8 flex-shrink-0" />
        <div className="min-w-0 flex-1">
          <div className={'text-sm font-medium'}>{org.display_name}</div>
        </div>
      </div>
      <RadioGroupItem
        value={org.id}
        className="mt-2 h-5 w-5 shrink-0 items-center justify-center p-0"
      />
    </label>
  );
};
